// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'
import { NetblockSourceTypeSchema } from '../inputTypeSchemas/NetblockSourceTypeSchema'

/////////////////////////////////////////
// NET BLOCK SCHEMA
/////////////////////////////////////////

/**
 * Owned or in-scope IP range. Roots back to ExternalNetwork; contains many Hosts.
 */
export const NetBlockSchema = z.object({
  scope: ScopeSchema,
  sourceType: NetblockSourceTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  parentId: z.string().nullable(),
  cidr: z.string(),
  version: z.number().int(),
  expansionProcessedAt: z.coerce.date().nullable(),
  cloudProvider: z.string().nullable(),
  cloudAccountRef: z.string().nullable(),
  cloudAllocationId: z.string().nullable(),
  cloudResourceKind: z.string().nullable(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type NetBlock = z.infer<typeof NetBlockSchema>

export default NetBlockSchema;
